import React from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { themes } from '@olist/design-system-tokens';

var DEFAULT_PREFIX = 'olist';
var DEFAULT_THEME_NAME = 'olist';
var DEFAULT_VARIATION_NAME = 'base';
var FALLBACK_THEME_WARNING = '[olistds] Wrong theme specified. Loading fallback theme.';
var DEFAULT_THEME = themes[DEFAULT_THEME_NAME][DEFAULT_VARIATION_NAME];
var getTheme = function (theme, variation) {
    if (theme === void 0) { theme = DEFAULT_THEME_NAME; }
    if (variation === void 0) { variation = DEFAULT_VARIATION_NAME; }
    try {
        return (themes[theme][variation] || DEFAULT_THEME);
    }
    catch (e) {
        console.error(FALLBACK_THEME_WARNING);
    }
    return DEFAULT_THEME;
};
var ThemeProvider = function (_a) {
    var _b;
    var children = _a.children, theme = _a.theme, variation = _a.variation;
    var currentTheme = getTheme(theme, variation);
    return (React.createElement(ThemeProvider$1, { theme: (_b = {},
            _b[DEFAULT_PREFIX] = currentTheme,
            _b) }, children));
};

export { FALLBACK_THEME_WARNING, ThemeProvider as default, getTheme };
